import React from 'react'
import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'

import RegionTagList from 'gms-support/src/app-support/regions/components/List'
import NewRegion from 'gms-support/src/app-support/regions/components/NewRegion'
import EditRegion from 'gms-support/src/app-support/regions/components/EditRegion'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_REGIONS } from 'app-support/permissions/Permissions'
import { regionsRoute, regionsRouteEdit, regionsRouteNew } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(regionsRoute)

const RegionsContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_REGIONS} exact path={regionsRoute} component={RegionTagList} />
    <PermissionRoute permission={PERMISSION_MANAGE_REGIONS} exact path={regionsRouteNew} component={NewRegion} />
    <PermissionRoute permission={PERMISSION_MANAGE_REGIONS} exact path={regionsRouteEdit} component={EditRegion} />
  </Switch>
)

export default enhance(RegionsContainer)
